module.exports = __webpack_public_path__ + "static/media/background.a8833803.svg";